const isDev = () => process.env.PREACT_APP_ENVIRONMENT === 'development';
export default isDev;
